import * as React from 'react';

import Logo from '@liveauctioneers/caterwaul-components/lib/Assets/Logo';
import styled from 'styled-components';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

const LoadingScreen = () => {
    return (
        <LoadingScreenWrapper>
            <LoadingScreenContent>
                <Logo
                    height="30px"
                    type="brand"
                    width="181px"
                />
                <Throbber />
            </LoadingScreenContent>
        </LoadingScreenWrapper>
    );
};

const LoadingScreenWrapper = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    z-index: 2000;
`;
const LoadingScreenContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 26px;
`;

export default LoadingScreen;
